import React, { useEffect, useState } from 'react';
import NavLogo from '../../components/NavLogo';
import Logo from '../../components/Logo';
import HeaderBanner from '../../layouts/HeaderBanner';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addEntityProfile, getEntity, getEntityProfileList } from '../../utils/actions';
import WelcomeBanner from '../../layouts/WelcomeBanner';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { format } from 'date-fns';


const WarehouseOperatorIndex = () => {

    const { entity_id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorVal, setError] = useState("");

    const account = JSON.parse(localStorage.getItem('account'));
    const [profilesList, setProfilesList] = useState([]);
    const [profileListLoading, setProfileListloading] = useState(false);
    const [profileListError, setProfileListError] = useState("");

    const [entityLoading, setEntityloading] = useState(false);
    const [entityError, setEntityError] = useState("");
    const [entityData, setEntityData] = useState("");

    const closeModal = () => {
        setIsModalOpen(false);
    };

    // Open Modal And Fetch Organization Details
    const openModal = () => {
        const fetchEntity = async () => {

            try
            {
                dispatch(getEntity(entity_id));
            } catch (error)
            {
                console.error(error);
            }
        };
        fetchEntity();
        setIsModalOpen(true);
    };

    // Listen to Changes In Entity State
    const organization_entity = useSelector((state) => state.getEntity);

    // UseEffect to Listen to Organization Reducer State Changes
    useEffect(() => {
        if (organization_entity.loading)
        {
            setEntityloading(true);
        }
        else
        {
            setEntityloading(false);
            if (organization_entity.error)
            {
                if (organization_entity.error.includes("404"))
                {
                    setEntityError("Error Loading Organization Data.");
                }
            }
            else
            {
                if (organization_entity.data) 
                {
                    setEntityData(organization_entity.data);
                    formik.setFieldValue('entity_mid', organization_entity.data.organization_id
                    );
                    formik.setFieldValue('member_type_id', `${organization_entity.data.organization_id
                        }WO`);
                }
            }
        }
    }, [organization_entity]);


    // Fetch Profile Lists Under this Entity
    useEffect(() => {
        const fetchProfileList = async () => {

            try
            {
                dispatch(getEntityProfileList(entity_id));
            } catch (error)
            {
                console.error(error);
            }
        };
        fetchProfileList();
    }, []);

    // Retrieve Profile List from State
    const profile_list = useSelector((state) => state.entityProfilesList);

    useEffect(() => {
        if (profile_list.loading)
        {
            setProfileListloading(true);
        }
        else
        {
            setProfileListloading(false);
            if (profile_list.error)
            {
                if (profile_list.error.includes("404"))
                {
                    setProfileListError("No Warehouses Found");
                }
            }
            else
            {
                if (profile_list.data) 
                {
                    const filter_warehouse_operator = profile_list?.data?.filter((profile) => profile.type === "warehouse_operator");
                    setProfilesList(filter_warehouse_operator);
                }
            }
        }
    }, [profile_list]);

    const addEntityProfileSchema = yup.object().shape({
        entity_name: yup.string().required('Warehouse Operator Profile Name is Required')
    });

    const formik = useFormik({
        initialValues: {
            entity_id: entity_id,
            type: "warehouse_operator",
            member_type_id: "",
            entity_name: '',
            entity_mid: "",
            active: 0,
            status: "created",
            history: [],
        },
        validationSchema: addEntityProfileSchema,


        onSubmit: async (values) => {

            setError("");
            setLoading(true);

            try
            {
                const timestamp = new Date();
                const formattedTimestamp = format(timestamp, 'MMMM dd, yyyy hh:mm a');
                const historyStatement = `Created Membership Account ${values.entity_name} on ${formattedTimestamp}`;

                const entity_profile = {
                    entity_id: values.entity_id,
                    type: values.type,
                    member_type_id: values.member_type_id,
                    entity_name: values.entity_name,
                    entity_mid: values.entity_mid,
                    active: values.active,
                    status: values.status,
                    roles: account?.profiles[0].roles,
                    history: [historyStatement],
                };

                dispatch(addEntityProfile(entity_profile));

                dispatch(getEntityProfileList(entity_id));

                closeModal();

                setProfileListError("");

            } catch (error)
            {
                if (error.response)
                {
                    if (error.response.status === 500)
                    {
                        setError(error.response.data.error);
                    }
                    else
                    {
                        setError(error.message);
                    }
                }
                else
                {
                    setError(error.message);
                }
            } finally
            {
                setLoading(false);
            }

        },
    });

    // Handle Logout
    const handleLogout = () => {
        localStorage.clear();
        navigate("/");
    };

    return (
        <>
            <button data-drawer-target="logo-sidebar" data-drawer-toggle="logo-sidebar" aria-controls="logo-sidebar" type="button" className="inline-flex items-center p-2 mt-2 ml-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
                <span className="sr-only">Open sidebar</span>
                <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd" fill-rule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
                </svg>
                <NavLogo />
            </button>

            <aside id="logo-sidebar" className="fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0" aria-label="Sidebar">
                <div className="h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800">
                    <a href="/" className="flex items-center pl-2.5 mb-5">
                        <Logo /></a>

                    <ul className="space-y-2 font-medium relative">
                        <li>
                            <a href="/home" className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg class="w-6 h-6 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6.143 1H1.857A.857.857 0 0 0 1 1.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 6.143V1.857A.857.857 0 0 0 6.143 1Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 17 6.143V1.857A.857.857 0 0 0 16.143 1Zm-10 10H1.857a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 16.143v-4.286A.857.857 0 0 0 6.143 11Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286a.857.857 0 0 0-.857-.857Z" />
                                </svg>
                                <span className="ml-3">My Dashboards</span>
                            </a>
                        </li>
                        <li>
                            <a href="/" className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg class="w-6 h-6 dark:text-white" aria-hidden="true" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.5 8C5.80777 8 5.13108 7.79473 4.55551 7.41015C3.97993 7.02556 3.53133 6.47893 3.26642 5.83939C3.00152 5.19985 2.9322 4.49612 3.06725 3.81719C3.2023 3.13825 3.53564 2.51461 4.02513 2.02513C4.51461 1.53564 5.13825 1.2023 5.81719 1.06725C6.49612 0.932205 7.19985 1.00152 7.83939 1.26642C8.47893 1.53133 9.02556 1.97993 9.41015 2.55551C9.79473 3.13108 10 3.80777 10 4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M6.5 17H1V15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.5 11H18.38C18.2672 10.5081 18.0714 10.0391 17.801 9.613L18.601 8.818C18.6947 8.72424 18.7474 8.59708 18.7474 8.4645C18.7474 8.33192 18.6947 8.20476 18.601 8.111L17.894 7.404C17.8002 7.31026 17.6731 7.25761 17.5405 7.25761C17.4079 7.25761 17.2808 7.31026 17.187 7.404L16.392 8.204C15.9647 7.93136 15.4939 7.73384 15 7.62V6.5C15 6.36739 14.9473 6.24021 14.8536 6.14645C14.7598 6.05268 14.6326 6 14.5 6H13.5C13.3674 6 13.2402 6.05268 13.1464 6.14645C13.0527 6.24021 13 6.36739 13 6.5V7.62C12.5081 7.73283 12.0391 7.92863 11.613 8.199L10.818 7.404C10.7242 7.31026 10.5971 7.25761 10.4645 7.25761C10.3319 7.25761 10.2048 7.31026 10.111 7.404L9.404 8.111C9.31026 8.20476 9.25761 8.33192 9.25761 8.4645C9.25761 8.59708 9.31026 8.72424 9.404 8.818L10.204 9.618C9.9324 10.0422 9.73492 10.5096 9.62 11H8.5C8.36739 11 8.24021 11.0527 8.14645 11.1464C8.05268 11.2402 8 11.3674 8 11.5V12.5C8 12.6326 8.05268 12.7598 8.14645 12.8536C8.24021 12.9473 8.36739 13 8.5 13H9.62C9.73283 13.4919 9.92863 13.9609 10.199 14.387L9.404 15.182C9.31026 15.2758 9.25761 15.4029 9.25761 15.5355C9.25761 15.6681 9.31026 15.7952 9.404 15.889L10.111 16.596C10.2048 16.6897 10.3319 16.7424 10.4645 16.7424C10.5971 16.7424 10.7242 16.6897 10.818 16.596L11.618 15.796C12.0422 16.0676 12.5096 16.2651 13 16.38V17.5C13 17.6326 13.0527 17.7598 13.1464 17.8536C13.2402 17.9473 13.3674 18 13.5 18H14.5C14.6326 18 14.7598 17.9473 14.8536 17.8536C14.9473 17.7598 15 17.6326 15 17.5V16.38C15.4919 16.2672 15.9609 16.0714 16.387 15.801L17.182 16.601C17.2758 16.6947 17.4029 16.7474 17.5355 16.7474C17.6681 16.7474 17.7952 16.6947 17.889 16.601L18.596 15.894C18.6897 15.8002 18.7424 15.6731 18.7424 15.5405C18.7424 15.4079 18.6897 15.2808 18.596 15.187L17.796 14.392C18.0686 13.9647 18.2662 13.4939 18.38 13H19.5C19.6326 13 19.7598 12.9473 19.8536 12.8536C19.9473 12.7598 20 12.6326 20 12.5V11.5C20 11.3674 19.9473 11.2402 19.8536 11.1464C19.7598 11.0527 19.6326 11 19.5 11ZM14 14.5C13.5055 14.5 13.0222 14.3534 12.6111 14.0787C12.2 13.804 11.8795 13.4135 11.6903 12.9567C11.5011 12.4999 11.4516 11.9972 11.548 11.5123C11.6445 11.0273 11.8826 10.5819 12.2322 10.2322C12.5819 9.8826 13.0273 9.6445 13.5123 9.54804C13.9972 9.45157 14.4999 9.50108 14.9567 9.6903C15.4135 9.87952 15.804 10.2 16.0787 10.6111C16.3534 11.0222 16.5 11.5055 16.5 12C16.5 12.663 16.2366 13.2989 15.7678 13.7678C15.2989 14.2366 14.663 14.5 14 14.5Z" fill="currentColor" />
                                </svg>

                                <span className="flex-1 ml-3 whitespace-nowrap">My Profile</span>
                            </a>
                        </li>
                        <li className="my-2 fixed bottom-12 w-11/12">
                            <a onClick={handleLogout} className="cursor-pointer flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                                <svg class="w-6 h-6 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h11m0 0-4-4m4 4-4 4m-5 3H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3" />
                                </svg>
                                <span className="flex-1 ml-3 whitespace-nowrap">Sign Out</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </aside>


            <div className="p-4 sm:ml-64">
                <div className="p-4 rounded-lg dark:border-gray-700">
                    <WelcomeBanner bannerTitle='Warehouse Operator Dashboard' />

                    <div className="header flex justify-between items-center">
                        <h5 className="text-xl font-bold dark:text-white mb-3 text-gray-700">Warehouse Operator Profiles</h5>{
                            !profileListLoading && (
                                <>
                                    {
                                        profilesList.length === 0 && (
                                            <>
                                                <button
                                                    type="button"
                                                    onClick={openModal}
                                                    className="mb-4 flex items-center justify-center px-4 py-2 text-sm bg-gray-100 font-medium text-gray-90 border-rouned-md border-gray-200 border-2 rounded-lg bg-sate-100 hover:border-primary-700 hover:text-green-800 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20"
                                                        fill="currentColor"
                                                        className="w-5 h-5 mr-2"
                                                    >
                                                        <path d="M5.433 13.917l1.262-3.155A4 4 0 017.58 9.42l6.92-6.918a2.121 2.121 0 013 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 01-.65-.65z" />
                                                        <path d="M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0010 3H4.75A2.75 2.75 0 002 5.75v9.5A2.75 2.75 0 004.75 18h9.5A2.75 2.75 0 0017 15.25V10a.75.75 0 00-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5z" />
                                                    </svg>
                                                    Add Warehouse Profile
                                                </button>
                                            </>
                                        )
                                    }
                                </>
                            )
                        }
                    </div>

                    {
                        profileListLoading ?
                            <>
                                <div className='flex flex-1 justify-center items-center'><div className="text-center">
                                    <div role="status">
                                        <svg
                                            aria-hidden="true"
                                            className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-600"
                                            viewBox="0 0 100 101"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="currentColor"
                                            />
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill"
                                            />
                                        </svg>
                                        <span className="text-gray-700">Loading Warehouse Profiles...</span>
                                        <span className="sr-only">Loading Warehouse Profiles...</span>
                                    </div>
                                </div>
                                </div>
                            </>
                            :
                            <>

                                <div className="grid md:grid-cols-2 gap-4 mb-4">
                                    {
                                        profileListError ?
                                            <>

                                            </>
                                            :
                                            <>
                                                {
                                                    profilesList?.map((profile) => {
                                                        return (
                                                            <>
                                                                <a href={`/warehouse/${entity_id}/${profile.entity_mid}`} class="each flex hover:shadow-lg select-none p-6 rounded-md border-gray-300 border mb-3 hover:border-green-500 cursor-pointer">
                                                                    <div>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-green-600">
                                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
                                                                        </svg>

                                                                    </div>
                                                                    <div className="flex flex-col ml-2">
                                                                        <span className="text-lg font-bold leading-5 text-green-600 mb-1">{profile.entity_name}</span>
                                                                        <span className="mt-1 text-sm text-gray-500 hidden md:block">Profile ID:<span className='ml-2 text-gray-900 font-bold'>{profile.member_type_id}</span></span>
                                                                    </div>
                                                                </a>
                                                            </>
                                                        );
                                                    })
                                                }
                                            </>
                                    }
                                </div>
                            </>
                    }
                </div>
            </div>
            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 overflow-y-auto">
                    <div className="fixed inset-0 bg-black opacity-50"></div>
                    {/* Modal content goes here */}
                    <div className="relative p-4 bg-white lg:w-4/12 w-5/6 rounded-lg shadow dark:bg-gray-800 md:p-8 max-h-screen overflow-y-auto">
                        {/* Add your modal content here */}
                        <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 dark:border-gray-600">
                            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                                Add a Warehouse Operator Profile
                            </h3>
                            <button type="button" onClick={closeModal} class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-toggle="updateProductModal">
                                <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                                <span class="sr-only">Close modal</span>
                            </button>
                        </div>
                        <form className="space-y-4 md:space-y-6" onSubmit={formik.handleSubmit}>
                            {errorVal && errorVal.length > 0 && (
                                <div className="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
                                    <span className="font-medium">Error: </span>
                                    {errorVal}
                                </div>
                            )}
                            <div className="mb-6">
                                <label htmlFor="entity_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Profile Name</label>
                                <input
                                    type="text"
                                    name="entity_name"
                                    value={formik.values.entity_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className="bg-gray-100 border border-gray-100 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                />
                                {formik.touched.entity_name && formik.errors.entity_name && (
                                    <p className="text-red-500 text-sm mt-1">{formik.errors.entity_name}</p>
                                )}
                            </div>
                            <div className="mb-6">
                                <label htmlFor="warehouse_operator" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Member Type</label>
                                <input
                                    type="text"
                                    name="warehouse_operator"
                                    value="Warehouse Operator"
                                    disabled
                                    className="bg-gray-50 border-bottom border-gray-100 text-gray-700 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                />
                            </div>
                            {
                                entityLoading ?
                                    <>
                                        <div className='flexflex-row justify-center items-center'>
                                            <div className="text-center">
                                                <div role="status">
                                                    <svg
                                                        aria-hidden="true"
                                                        className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-600"
                                                        viewBox="0 0 100 101"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                            fill="currentColor"
                                                        />
                                                        <path
                                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                            fill="currentFill"
                                                        />
                                                    </svg>
                                                    <span className="sr-only">Loading Organization Details...</span>
                                                    <span className="text-gray-700">Loading Organization Details...</span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        {
                                            entityError ?
                                                <>
                                                    <div className="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
                                                        <span className="font-medium">Error: </span>
                                                        {entityError}
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    {
                                                        entityData && (
                                                            <>
                                                                <div className="mb-6">
                                                                    <label htmlFor="warehouse_operator" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Organization ID</label>
                                                                    <input
                                                                        type="text"
                                                                        name="warehouse_operator"
                                                                        value={entityData.organization_id && (entityData.organization_id)}
                                                                        disabled
                                                                        className="bg-gray-50 border-bottom border-gray-100 text-gray-700 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                                                    />
                                                                </div>
                                                                <div className="mb-6">
                                                                    <label htmlFor="warehouse_operator" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Member Profile ID</label>
                                                                    <input
                                                                        type="text"
                                                                        name="warehouse_operator"
                                                                        value={entityData.organization_id && (`${entityData.organization_id}WO`)}
                                                                        disabled
                                                                        className="bg-gray-50 border-bottom border-gray-100 text-gray-700 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                                                    />
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </>
                                        }
                                    </>
                            }
                            {/* Close button */}
                            <div className="flex space-x-4">
                                <button
                                    type="button"
                                    onClick={closeModal}
                                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2"
                                >
                                    Close Modal
                                </button>
                                {
                                    entityData && (
                                        <button
                                            type="submit"
                                            //   disabled={!formik.isValid}
                                            className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-primary-800 mr-2 mb-2"
                                        >

                                            {formik.isSubmitting ? 'Adding Warehouse Operator Profile...' : 'Add Warehouse Operator Profile'}
                                        </button>
                                    )
                                }
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default WarehouseOperatorIndex;